
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"48","height":"48","rx":"6","fill":"#EAE3F2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.25 12a3.75 3.75 0 000 7.5A5.25 5.25 0 0012 24.75v3c0 .414.336.75.75.75h.821l.683 6.825A.75.75 0 0015 36h4.5a.75.75 0 00.746-.675l.683-6.825h.821a.75.75 0 00.75-.75v-3a5.25 5.25 0 00-5.25-5.25 3.75 3.75 0 000-7.5zm-.75 14.25v-5.174a3.75 3.75 0 00-3 3.674V27h.75a.75.75 0 01.746.675l.683 6.825h3.142l.683-6.825A.75.75 0 0120.25 27H21v-2.25a3.75 3.75 0 00-3-3.674v5.174a.75.75 0 01-1.5 0zm-.841-12.091a2.25 2.25 0 113.182 3.183 2.25 2.25 0 01-3.182-3.183z","fill":"#481D72"}}),_c('path',{attrs:{"d":"M23.25 12a.75.75 0 000 1.5h10.5a.75.75 0 01.75.75V27a.75.75 0 01-.75.75h-9a.75.75 0 000 1.5h9A2.25 2.25 0 0036 27V14.25A2.25 2.25 0 0033.75 12h-10.5z","fill":"#481D72"}})])
          )
        }
      }
    